<template>
    <footer class="footer">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="copyright">{{ new Date() | moment("YYYY") }} &copy {{ getSnippets('Copyright') }}. {{ getSnippets('Development') }} <a href="https://smoothcoding.net/" target="_blank">Smooth Coding</a>.</div>
                </div>
                <div class="col-lg-6">
                    <ul class="navigation-list">
                        <li class="nav-item" v-for="item in bottom" :key="item.id">
                            <router-link class="nav-link" :to="{ path: item.slug }">{{ item.translations[locality].title }}</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    /* Mixins */
    import { Default } from '@mixins/Default'

    /* Logic */
    export default {
        name: "Footer",
        mixins: [Default],
        props: [
            'currency',
            'locality',
            'navigation',
            'snippets',
            'slugs',
            'translatable',
        ],
        data: function () {
            return {
                main: '',
                bottom: '',
                both: '',
                shop: ''
            }
        },
        methods: {
            fetchItems: function () {
                this.main = this.navigation.main
                this.bottom = this.navigation.bottom
                this.both = this.navigation.both
                this.shop = this.navigation.shop
            }
        },
        watch: {
            locality: function() {
                this.initialize()
                this.fetchItems()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/App/Partials/Footer.vue